import { CircularProgress, Stack, Typography } from '@mui/material';

const InitLoadingSpinner = () => (
  <Stack width="100%" height="100vh" spacing={4} justifyContent="center" alignItems="center">
    <Typography variant="h3">Healthcare Data Platform is Loading...</Typography>
    <CircularProgress size={40} sx={{ color: '#1010eb' }} />
  </Stack>
);

export default InitLoadingSpinner;
